module.exports = __webpack_public_path__ + "static/media/uninow_logo_white.28997d02.svg";